import { ValueObject, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class ClientAccountSearchCriteria extends ValueObject {
    public searchCriteria: string = "";
}